// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalBiRequestSearchDefaultResponse {
    static getAttributeTypeMap() {
        return MedicalV1MedicalBiRequestSearchDefaultResponse.attributeTypeMap;
    }
}
MedicalV1MedicalBiRequestSearchDefaultResponse.discriminator = undefined;
MedicalV1MedicalBiRequestSearchDefaultResponse.additionalProperties = false;
MedicalV1MedicalBiRequestSearchDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "MedicalV1MedicalBiRequestSearchDefaultResponseData"
    },
];
//# sourceMappingURL=medicalV1MedicalBiRequestSearchDefaultResponse.js.map